import { useId } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import type { IFormFieldProps, ITextareaProps } from "@/ui-kit";
import { FormField, Textarea } from "@/ui-kit";
import { get } from "../utils";

type IProps = Omit<ITextareaProps, "label"> &
  Partial<IFormFieldProps> & {
    name: string;
    formElementClass?: string;
  };

export const TextareaControl = (props: IProps) => {
  const {
    label,
    message,
    required,
    tooltipContent,
    accessory,
    formElementClass,
    name,
    invalid,
    description,
    ...restTextareaProps
  } = props;
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const textareaId = useId();

  const inputElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, onBlur, value } }) => {
        return (
          <Textarea
            {...restTextareaProps}
            required={required}
            name={name}
            onChange={onFieldChange}
            onBlur={onBlur}
            value={value}
            invalid={invalid || !!errorMessage}
            id={textareaId}
          />
        );
      }}
    />
  );

  return (
    <FormField
      label={label}
      message={message ?? errorMessage}
      description={description}
      required={required}
      tooltipContent={tooltipContent}
      className={formElementClass}
      accessory={accessory}
      htmlFor={textareaId}
    >
      {inputElement}
    </FormField>
  );
};
